import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ThemeProvider from 'react-bootstrap/ThemeProvider';

import Header from './components/Header';
import Companies from './components/company/Companies';

function App() {
  return (
    <ThemeProvider breakpoints={['xl', 'lg', 'md', 'sm', 'xs']}>
      <div className="wrapper">
        <Header />
        <Routes>
          <Route path="/" element={<Companies />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
